module.exports = __webpack_public_path__ + "assets/img/back-f745ed04.png";